import moment from "moment";
import React from "react";
import { Link } from "react-router-dom";
import { Button } from "reactstrap";

import RemoveIcon from "../Icons/RemoveIcon";


const Columns3 = ({handleRemoveDocumentoAsignado}) => [
  {
    dataField: "menu",
    isDummyField: true,
    text: "Acciones",
    style: { width: "5%" },
   
    formatter: (cellContent, row) => {
      return (
        <>
          <div
            key={`outboundcolumns_${row?.id}`}
            className="btn-group  mt-md-0"
            size="sm"
            role="group"
          >
            <Button
              style={{ padding: "0.5em" }}
             
              title="Eliminar"
              onClick={() => handleRemoveDocumentoAsignado(row)}
              type="button"
              color="light"
            >
              <RemoveIcon width="20px" />
              
            </Button>

         
          </div>
        </>
      );
    },
  },
  {
    dataField: "nroDocument",
    text: "Nro IRCH",
    sort: true,
    style: { width: "5%" },
  },
  {
    dataField: "providerName",
    text: "Remito",
    sort: true,
    style: { width: "10%" },
  },
  {
    dataField: "pInsumo",
    text: "N° P. Insumo",
    sort: true,
    style: { width: "5%" },
  },
  // {
  //   dataField: "itemName2",
  //   text: "Ticket",
  //   sort: true,
  //   style: { width: "10%" },
  // },
  { dataField: "peso", text: "Peso", sort: true, style: { width: "5%" } },
  {
    dataField: "date",
    text: "Fecha",
    sort: true,
    style: { width: "10%" },
    formatter: (cellContent, row) => moment(cellContent).format("DD-MM-YYYY"),
  },
];

export default Columns3;
